import { Flex, Paper, TertiarySmall, Link } from "@base-ui";
import { SingleColumnPage } from "@templates/pageLayouts";
import Image from "@cms/components/ui/Image";
import IconQuote from "@cms/components/ui/IconQuote";
import fallbackImg from "assets/ux/vis_start_fallback.jpg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UnAuthorized() {
  var infographicContent = {
    id: "unauthorized-iconquote",
    src: "locked",
    alt: "Ikon föreställande blockerat innehåll",
    formattedText: JSON.stringify({
      ops: [{
        insert: "Sidan du försöker komma åt har begränsad åtkomst. Säkerställ att du har skrivit in korrekt address."
      }]
    })
  };
  return /*#__PURE__*/_jsx(SingleColumnPage, {
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      mb: "-20px",
      position: "relative",
      backgroundColor: "V3",
      children: [/*#__PURE__*/_jsx(Image, {
        id: "unauthorized-image",
        src: fallbackImg,
        alt: "",
        minHeight: "600px",
        maxHeight: "calc(100vh - 300px)",
        opacity: 0.4
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex"
        },
        children: /*#__PURE__*/_jsxs(Paper.Column, {
          p: "md",
          width: "fit-content",
          margin: "auto",
          maxWidth: "450px",
          children: [/*#__PURE__*/_jsx(TertiarySmall, {
            m: "0 auto 20px",
            children: "403: Forbidden"
          }), /*#__PURE__*/_jsx(IconQuote, {
            iconQuote: infographicContent,
            p: "0"
          }), /*#__PURE__*/_jsx(Link, {
            to: "/",
            m: "10px auto 0",
            width: "fit-content",
            children: "G\xE5 tillbaka till startsidan"
          })]
        })
      })]
    })
  });
}